import { OPENID_KEY, OFFICIAL_ACCOUNT_CODE_KEY, TOKEN } from '@/constants';
import { useUserStore } from '@/store';
import { fetcher } from '@/services/graphql/fetcher/index';
import { commonUtils, storage, toast } from '@/utils';
import { fetchGetJsConfigDocument } from '../graphql/docs';
// #ifdef H5
import WechatSDK from 'weixin-js-sdk';
import localConf from '@/local-conf';
// #endif

export default async () => {
  // 先判断缓存
  const cache = await storage.get(OPENID_KEY);
  if (!cache) {
    // 获取url参数
    const params = commonUtils.url.getAllParams(location.href);
    const H5openIdKey = params[OPENID_KEY];
    if (!H5openIdKey) {
      storage.remove(OPENID_KEY);
      locationHref();
    } else {
      // 缓存openkey
      storage.set(OPENID_KEY, H5openIdKey, 1);

      // 从 URL 上移除 openIdKey 参数，避免刷新时重复使用或残留
      const url = new URL(window.location.href);
      url.searchParams.delete(OPENID_KEY);
      window.history.replaceState({}, '', url.toString());
    }
  }
};

/** 授权跳转 */
const locationHref = () => {
  location.href = `${localConf.host}/wx/inlet?channelToken=${localConf.channel}&scope=snsapi_userinfo&returnUrl=${encodeURIComponent(window.location.href)}&host=${localConf.host?.split('//')[1]}`;
};

/** 初始化config */
export const initH5WechatSDKConfig = async () => {
  try {
    const res = await fetcher.mutation(fetchGetJsConfigDocument, {
      url: location.href,
    });

    const config = res.data.getJsConfig;

    if (config) {
      const { appId, timestamp, nonceStr, signature, officialAccountCode } = config;

      // 检测 officialAccountCode 是否变更（即 appId 是否切换了）
      const cachedCode = storage.get(OFFICIAL_ACCOUNT_CODE_KEY);
      if (cachedCode && officialAccountCode && cachedCode !== officialAccountCode) {
        console.log('[officialAccountCode 变更] 重新授权', { old: cachedCode, new: officialAccountCode });
        storage.remove(TOKEN);
        storage.remove(OPENID_KEY);
        storage.remove(OFFICIAL_ACCOUNT_CODE_KEY);
        useUserStore().isLogin = false;
        locationHref();
        return;
      }

      if (officialAccountCode) {
        storage.set(OFFICIAL_ACCOUNT_CODE_KEY, officialAccountCode);
      } else {
        storage.remove(OFFICIAL_ACCOUNT_CODE_KEY);
      }

      WechatSDK.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来
        appId, // 必填，企业号的唯一标识，此处填写企业号corpid
        timestamp, // 必填，生成签名的时间戳
        nonceStr, // 必填，生成签名的随机串
        signature, // 必填，签名，见附录1
        jsApiList: ['chooseWXPay', 'scanQRCode', 'getLocation', 'openAddress', 'hideMenuItems', 'showAllNonBaseMenuItem', 'updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareAppMessage', 'onMenuShareTimeline'], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        openTagList: ['wx-open-subscribe']
      });
    }
  } catch (error) {
    toast.message('初始化配置失败');
  }
};
